import { Navigate } from "react-router-dom";
import Dashboard from "../pages/Dashboard";

// Auth
import Login from "pages/Authentication/login";
import Logout from "pages/Authentication/Logout";
import ForgotPassword from "pages/Authentication/ForgotPassword";
import SignUp from "pages/Authentication/Register";
import CountrySection from "pages/CountrySection";
import ProductReport from "pages/ProductReport";
import Requote from "pages/Requote";
import FinalDocumentVerify from "pages/FinalDocumentVerify";
import SuccessScreen from "pages/SuccessScreen";
import Reschedule from "pages/Reschedules";
import ProductThreshold from "pages/ProductThreshold/ProductThreshold";
import AgentTicketView from "pages/AgenttTcketView";
import UserDashboard from "pages/User/UserDashboard/UserDashboard";
import UserRoleScreen from "pages/ScreenActivity";
import UserRoleScreenActivity from "pages/ScreenActivity/UserScreenActivity";
import UserProfile from "pages/Authentication/user-profile";
import FindLocationDashboard from "pages/FindLocationDashboard/FindLocationDashboard";
import FeedBack from "pages/FeedBack/FeedBack";
import OrderSchedules from "pages/OrderSchedules";
import Import from "pages/Import/Import";
import SEODashboard from "pages/seo";
import SEOEdit from "pages/seo/Seo";
import BecomeAPartner from "pages/BecomeAPartner";
import CorporateInTrade from "pages/CorporateTrade";
import HomePage from "pages/homepage";
import ProductValue from "pages/productvalue/ProductValue";
import BlogDashboard from "pages/blog/BlogDashboard/BlogDashboard";
import BlogCreateEdit from "pages/blog/BlogCreateEdit";
import OrderSummaryView from "pages/AuditScreen";
import ImportHistoryList from "pages/ImportHistory";
import ImportTransactionView from "pages/ImportHistory/ImportTransactionView";

const authProtectedRoutes = [
  { path: "/dashboard/:routeId", component: <Dashboard /> },
  { path: "/product-report", component: <ProductReport /> },
  { path: "/homepage", component: <HomePage /> },
  { path: "/agent-ticket-view/:encryptedId", component: <AgentTicketView /> },
  { path: "/re-quote/:encryptedId", component: <Requote /> },
  // { path: "/repair-requote/:encryptedId", component: <AgentTicketView /> },
  { path: "/final-documents-verify/:encryptedId", component: <FinalDocumentVerify /> },
  { path: "/success-screen/:encryptedId", component: <SuccessScreen /> },
  { path: "/re-schedule/:encryptedId", component: <Reschedule /> },
  { path: "/time-date-slot/:encryptedId", component: <Reschedule /> },
  { path: "/product-threshold", component: <ProductThreshold /> },
  { path: "/product-value", component: <ProductValue /> },
  { path: "/user-dashboard", component: <UserDashboard /> },
  { path: "/", exact: true, component: <Navigate to="/homepage" /> },
  { path: "/seo", component: <SEODashboard /> },
  { path: "/seo-edit/:pageId", component: <SEOEdit /> },
  { path: "/screen-accessibility", component: <UserRoleScreen /> },
  { path: "/screen-accessibility/:id", component: <UserRoleScreenActivity /> },
  { path: "/profile/:id", component: <UserProfile /> },
  { path: "/location-request", component: <FindLocationDashboard /> },
  { path: "/feedback-detail", component: <FeedBack /> },
  { path: "/order-schedule/:encryptedId", component: <OrderSchedules /> },
  { path: "/corporate-trade", component: <CorporateInTrade /> },
  { path: "/become-a-partner", component: <BecomeAPartner /> },
  { path: "/import", component: <Import /> },
  { path: "/blogs", component: <BlogDashboard /> },
  { path: "/blogcreateedit", component: <BlogCreateEdit /> },
  { path: "/blogcreateedit/:routeId", component: <BlogCreateEdit /> },
  { path: "/auditlog", component: <OrderSummaryView /> },
  { path: "/import-history", component: <ImportHistoryList /> },
  { path: "/import-history/:id", component: <ImportTransactionView /> }
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/register", component: <SignUp /> },
  { path: "/country-section", component: <CountrySection /> },



]
export { authProtectedRoutes, publicRoutes };
